import { render, staticRenderFns } from "./BizStartHour.vue?vue&type=template&id=1dbd30f2&scoped=true&lang=pug"
import script from "./BizStartHour.vue?vue&type=script&lang=js"
export * from "./BizStartHour.vue?vue&type=script&lang=js"
import style0 from "./BizStartHour.vue?vue&type=style&index=0&id=1dbd30f2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd30f2",
  null
  
)

export default component.exports